export default "__VITE_ASSET__331591dc__"